import { createGlobalStyle } from 'styled-components'
import { generateMedia } from 'styled-media-query'

import { COLOR } from '@/shared/constant/color'

export const CommonStyle = createGlobalStyle`
  * {
    box-sizing: border-box;
    -webkit-tap-highlight-color : rgba(0,0,0,0.1);
  }
  html, body {
    height: 100%;
  }
  a {
    text-decoration: none;
    color: black;
  }

  a:visited {
    text-decoration: none;
  }

  input {
    padding: 0;
  }

  input:focus {
    outline: none !important;
    border-color: ${COLOR.point1};
  }
  body {
    margin: 0;
  }

  button {
    cursor: pointer;    
    border: none; 
    background: none;
    padding: 0;
    margin: 0;
  }

  input[type="number"]::-webkit-outer-spin-button,
  input[type="number"]::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  
  table{
    width: 100%;
    border-collapse: collapse;
    th{
      background-color: #f1f1f1;
    }
    th, td{
      border: 1px solid #ccc;
      padding: 6px 8px;
    }
  }
  p, span, div, h1, h2, h3, h4, h5, h6 {
    margin: 0;
    padding: 0;
  }
`

export const customMedia = generateMedia({
  main1: '1920px',
  main1_2: '1750px',
  main1_3: '1500px',
  tablet: '1200px',
  tablet_cut_line: '600px',
  modal: '432px',
  mobile: '360px',
  main6: '768px',
  tabl4et: '1199px',
})
